import { PriceTagItem } from "./Item";
import { PriceTagList } from "./List";

const PriceTag = {
  Item: PriceTagItem,
  List: PriceTagList,
};

export default PriceTag;
